import { useEffect, useState, useCallback, useRef } from 'react';
import { supabase, sbError } from '@/lib/supabase';

// useInvoicesScoped(workspaceId | 'ALL' | null)
// - ak workspaceId je konkretne UUID -> filter podla workspace_id
// - ak workspaceId === 'ALL' -> bez filtra (RLS chrani user_id ownership)
// - ak workspaceId == null/undefined -> prazdny stav
export function useInvoicesScoped(workspaceId) {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const currentWsRef = useRef(workspaceId);
  currentWsRef.current = workspaceId;

  const fetch = useCallback(async () => {
    if (workspaceId == null) { setInvoices([]); setLoading(false); return; }
    const myWs = workspaceId;
    setLoading(true);
    let query = supabase
      .from('invoices')
      .select('*, client:clients(id, name, ico, dic, ic_dph, address, is_pinned, email, iban), workspace:workspaces(id, name, type)')
      .order('issue_date', { ascending: false })
      .order('created_at', { ascending: false });
    if (myWs !== 'ALL') query = query.eq('workspace_id', myWs);
    const { data, error } = await query;
    if (currentWsRef.current !== myWs) return;
    if (error) { setError(sbError(error)); setInvoices([]); }
    else { setInvoices(data || []); setError(null); }
    setLoading(false);
  }, [workspaceId]);

  useEffect(() => { fetch(); }, [fetch]);

  const update = useCallback(async (id, patch) => {
    const { data, error } = await supabase
      .from('invoices').update(patch).eq('id', id)
      .select('*, client:clients(id, name, ico, dic, ic_dph, address, is_pinned, email, iban), workspace:workspaces(id, name, type)')
      .single();
    if (error) throw new Error(sbError(error));
    await fetch();
    return data;
  }, [fetch]);

  return { invoices, loading, error, refresh: fetch, update };
}
